export default "__VITE_ASSET__9a4aa537__"